/* eslint-disable no-console */
import { LogLevel } from "@azure/msal-browser";
import { Env } from "./env";

/**
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
const b2cConfig = {
    clientId: Env.REACT_APP_B2C_CLIENT_ID,
    domain: Env.REACT_APP_B2C_DOMAIN,
    names: {
        signUpSignIn: Env.REACT_APP_B2C_SIGNIN,
        forgotPassword: Env.REACT_APP_B2C_FORGOTPASS
    },
    authorities: {
        signUpSignIn: {
            authority: Env.REACT_APP_B2C_AUTHORITY_SIGNIN
        },
        forgotPassword: {
            authority: Env.REACT_APP_B2C_AUTHORITY_FORGOTPASS
        }
    },
    authorityDomain: Env.REACT_APP_B2C_AUTHORITY_DOMAIN
};

/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: b2cConfig.clientId,
        authority: b2cConfig.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cConfig.authorityDomain],
        redirectUri: "/",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;

                    default:
                        break;
                }
            }
        }
    }
};

/**
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [`https://${b2cConfig.domain}/${b2cConfig.clientId}/login`]
};
